import React, { useState, useEffect } from 'react';
import Question from './Question';
import language from '../language';

const Quiz = ({ question, correctAnswers, onAnswerSubmit, showNextButton, onNextQuestion, isLastQuestion, totalQuestions, answeredQuestions, correctCount, wrongCount }) => {
    const [selectedAnswers, setSelectedAnswers] = useState([]);
    const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);

    useEffect(() => {
        setSelectedAnswers([]);
        setShowCorrectAnswer(false);
    }, [question]);

    const handleAnswerClick = (choice) => {
        setSelectedAnswers(prevSelectedAnswers => {
            if (prevSelectedAnswers.includes(choice)) {
                return prevSelectedAnswers.filter(answer => answer !== choice);
            } else {
                return [...prevSelectedAnswers, choice];
            }
        });
    };

    const handleSubmit = () => {
        setShowCorrectAnswer(true);
        const isCorrect = selectedAnswers.length === correctAnswers.length &&
                          selectedAnswers.every(answer => correctAnswers.includes(answer));
        onAnswerSubmit(isCorrect);
    };

    return (
        <div className="quiz">
            <div className="counter">
                {language.answeredQuestions}: {answeredQuestions} / {totalQuestions}
            </div>
            <div className="counter">
                {language.correctAnswers}: {correctCount}
            </div>
            <div className="counter">
                {language.wrongAnswers}: {wrongCount}
            </div>
            {question && (
                <>
                    <Question
                        questionText={question.question}
                        answers={question.answers}
                        selectedAnswers={selectedAnswers}
                        onAnswerClick={handleAnswerClick}
                        showCorrectAnswer={showCorrectAnswer}
                        correctAnswers={correctAnswers}
                    />
                    {!showNextButton ? (
                        <button onClick={handleSubmit}>{language.submit}</button>
                    ) : (
                        <button onClick={onNextQuestion}>
                            {isLastQuestion ? language.finishQuiz : language.nextQuestion}
                        </button>
                    )}
                    {showCorrectAnswer && (
                        <div className={selectedAnswers.length === correctAnswers.length && selectedAnswers.every(answer => correctAnswers.includes(answer)) ? 'correct-answer' : 'incorrect-answer'}>
                            {selectedAnswers.length === correctAnswers.length && selectedAnswers.every(answer => correctAnswers.includes(answer))
                                ? language.correct
                                : `${language.incorrect} ${language.correctAnswers} ${correctAnswers.join(', ')}.`}
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Quiz;